const translation = {
  toVerifiedTip: {
    coupon: 'coupon esclusivo al 100%',
    end: 'per il Piano Professionale Dify.',
    front: 'Ora sei idoneo per lo stato di Educazione Verificata. Per favore, inserisci le tue informazioni educative qui sotto per completare il processo e ricevere un',
  },
  form: {
    schoolName: {
      title: 'Il Nome della tua Scuola',
      placeholder: 'Inserisci il nome ufficiale e completo della tua scuola',
    },
    schoolRole: {
      option: {
        teacher: 'Insegnante',
        student: 'Studente',
        administrator: 'Amministratore scolastico',
      },
      title: 'Il tuo ruolo scolastico',
    },
    terms: {
      desc: {
        and: 'e',
        privacyPolicy: 'Informativa sulla privacy',
        end: '. Inviando:',
        front: 'Le tue informazioni e l\'uso dello stato di Educazione Verificato sono soggetti a nostri',
        termsOfService: 'Termini di servizio',
      },
      option: {
        inSchool: 'Confermo di essere iscritto o impiegato presso l\'istituzione fornita. Dify può richiedere una prova di iscrizione/impegno. Se rappresento erroneamente la mia idoneità, accetto di pagare eventuali tasse inizialmente esonerate in base al mio stato di istruzione.',
        age: 'Confermo di avere almeno 18 anni',
      },
      title: 'Termini e Accordi',
    },
  },
  toVerified: 'Fai verificare la tua istruzione',
  successTitle: 'Hai ottenuto l\'istruzione Dify verificata',
  submitError: 'Invio del modulo non riuscito. Per favore riprova più tardi.',
  submit: 'Invia',
  currentSigned: 'ATTUALMENTE ACCEDUTO COME',
  successContent: 'Abbiamo emesso un coupon sconto del 100% per il piano Dify Professionale sul tuo account. Il coupon è valido per un anno, ti preghiamo di utilizzarlo entro il periodo di validità.',
  learn: 'Scopri come far verificare la tua istruzione',
  emailLabel: 'La tua email attuale',
  rejectContent: 'Sfortunatamente, non sei idoneo per lo status di Educazione Verificata e quindi non puoi ricevere il coupon esclusivo del 100% per il Piano Professionale Dify se usi questo indirizzo email.',
  rejectTitle: 'La tua verifica educativa Dify è stata rifiutata.',
}

export default translation
